module.exports = __webpack_public_path__ + "static/media/home_icon.e0944c3b.svg";